import { clamp } from '../common/maths';
import { useStore } from '../state/ui-store';
import { getActiveEntryList, getLastEntryIndex } from './beinlich-govie';

export const getNextTargetTime = () => {
  const { pageIndex } = useStore.getState();
  const newVal6 = clamp(pageIndex + 1, 0, getLastEntryIndex());
  return getActiveEntryList()[newVal6];
};
